import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ReplaceBillingitemsWizardEffects } from './effects';
import * as fromReplaceBillingitemsWizard from './reducer';

export function provideReplaceBillingitemsWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromReplaceBillingitemsWizard.replaceBillingitemsWizardFeatureKey, fromReplaceBillingitemsWizard.reducer),
    provideEffects(ReplaceBillingitemsWizardEffects),
  ]);
}
